import React from "react";
import {FormControl, ControlLabel, Alert} from "react-bootstrap";
import context from "./../lib/context.js";
import ajax from "./../lib/ajax.js";
import TCDurationForm from "./tc-entry-duration/tc-duration-form.jsx";
import moment from "moment";
import immutable from "immutable";
import TCButtonPanel from "./shared/tc-button-panel.jsx";
import {browserHistory} from "react-router";

export default class FutureTCDuration extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            weekEndings : [],
            selectedTimecardId : null,
            selectedWeekEnding : null,
            timecard: null,
            hideButtonPanel: true,
            buttons: "",
            errors: []
        }

        this.onSelectedTimecardIdChanged = this.onSelectedTimecardIdChanged.bind(this);
        this.onNewTimecardAdded = this.onNewTimecardAdded.bind(this);      
        this.onDeleteTimecard = this.onDeleteTimecard.bind(this);
        this.onSubmitTimecard = this.onSubmitTimecard.bind(this);
        this.onLoadTimecardCompleted = this.onLoadTimecardCompleted.bind(this);
        this.deleteTimecard = this.deleteTimecard.bind(this);
    }

    onSelectedTimecardIdChanged(newValue) {
        const tokens = newValue.split("|");
        this.setState(immutable.fromJS(this.state)
            .mergeDeep({
                selectedTimecardId: parseInt(tokens[0]),
                selectedWeekEnding: moment(new Date(tokens[1])).format("MM/DD/YYYY")
            }).toJS());
    }

    onNewTimecardAdded(newTimecardId) {
        let self = this;
        ajax.vm()
            .get("people/future-tc-duration")
            .then(function(res) {  
                let data = res.data;
                for(let i=0; i< data.weekEndings.length; i++) {
                    if (newTimecardId == data.weekEndings[i].timecardId) {                           
                        data.selectedTimecardId = data.weekEndings[i].timecardId;
                        data.selectedWeekEnding = data.weekEndings[i].weekEnding;
                    }
                }
                data.selectedWeekEnding = moment(data.selectedWeekEnding).format("MM/DD/YYYY");
                self.setState(res.data);
            });
    }

    onSubmitTimecard() {
        const self = this;
        const timecardId = this.state.selectedTimecardId;
        let vm = this.state;
        let newNotes = this.refs.durationForm.refs.tcSummary.getNotes().trim();
        ajax.api()
            .put(`add-notes/${timecardId}`, {role: 'people', notes: newNotes})
            .then(function(res) {
                ajax.api()
                    .get(`prepare-timecard-submission/${timecardId}`)
                    .then(function (res) {
                        
                        if (res.data.errorMessages != null && res.data.errorMessages.length > 0) {
                            self.handleError(res.data.errorMessages, function () {
                                context.message({ show: false });
                            });
                        } else {
                            const submitToken = res.data.token
                            browserHistory.push(context.routeUrl(`people/tc-submit/${submitToken.timecardId}/${escape(submitToken.token)}`));
                            context.message({ show: false });
                        }
                    })
                    .catch(function(err) {
                        let errors = [];
                        let data = err.response.data;
                        if(data.exceptionMessage.length > 1 || data.message.length > 1) {
                            errors.push(data.exceptionMessage || data.message);
                        } else {
                            for(let k in data.data) {
                                errors.push(data.data[k]);
                            }
                        }

                        self.handleError(errors, function () {
                            context.message({ show: false });
                        });
                    });
            })
            .catch(function(err) {       
                const data = err.response.data;
                const msg = data.exceptionMessage || data.message;
                context.message({
                    show :true,
                    type : "error",
                    message: <div>Error when attempting to add notes.<br/>{msg}</div>,
                    buttons: "ok"
                });
            }); 
    }

    onDeleteTimecard() {
        let vm = this.state;
        const self = this;
        ajax.api()
            .get("timecard-has-unapproved-pto/" + vm.selectedTimecardId)
            .then(function (res) {

                let title = "";
                let msg = "Are you sure you want to delete this timecard?";
                let buttons = "yes,no";
                let type = "info";

                if (res.data) {
                    title = <span className="ap-pto-dialog-title"><i className="fa fa-calendar-o" /> Cancel Time-Off</span>;
                    msg = <div className="ap-mb-2"><b>This will cancel your Time-Off request.<br/>Are you sure you want to continue?</b></div>;
                    buttons = "continue,cancel";
                    type = "";
                }

                context.message({
                    show: true,
                    type: type,
                    title: title,
                    message: msg,
                    buttons: buttons
                }, function (button, s) {
                    // s is timecardId, timecardId is set as the 3rd parameter of context.message
                    if (button === "yes" || button === "continue") {
                        self.deleteTimecard(s)
                    }
                }, vm.selectedTimecardId);
            })
            .catch(function (err) {
                const data = err.response.data;
                const msg = data.exceptionMessage || data.message;
                context.message({
                    show: true,
                    type: "error",
                    message: <div>Error while deleting timecard.<br />{msg}</div>,
                    buttons: "ok"
                });
            });
    }

    deleteTimecard(timecardId) {
        const self = this;

        context.message({
            show: true,
            type: "loading",
            message: "Deleting Timecard. Please wait..."
        });
        ajax.api()
            .delete("delete-timecard/" + timecardId)
            .then(function (res) {
                window.location = context.routeUrl('people/future-tc-entry/');
            })
            .catch(function (err) {
                const data = err.response.data;
                const msg = data.exceptionMessage || data.message;
                context.message({
                    show: true,
                    type: "error",
                    message: <div>Error while deleting timecard.<br />{msg}</div>,
                    buttons: "ok"
                });
            });
    }

    componentDidMount() {
        const tid = this.props.location.query.tid;
        let self = this;
        ajax.vm()
            .get("people/future-tc-duration")
            .then(function(res) {                
                const data = res.data;
                if (tid) {
                    for(let i=0; i< data.weekEndings.length; i++) {
                        if (tid == data.weekEndings[i].timecardId) {
                            data.selectedTimecardId = data.weekEndings[i].timecardId;
                            data.selectedWeekEnding = data.weekEndings[i].weekEnding;
                        }
                    }
                }
                data.selectedWeekEnding = moment(data.selectedWeekEnding).format("MM/DD/YYYY");
                self.setState(data);
            });
    }  
    
    onLoadTimecardCompleted(tc) {
        const clone = immutable.fromJS(this.state).toJS();
        const buttonConfig = this.prepareButtonPanel(tc);
        clone.timecard = tc;
        clone.hideButtonPanel = buttonConfig.hideButtonPanel;
        clone.buttons = buttonConfig.buttons;
        clone.errors = [];
        this.setState(clone);
    }

    prepareButtonPanel(tc) {

        const result = {
            hideButtonPanel: true,
            buttons : ""
        };
        if (tc) {
            if (tc.statusCode.toLowerCase() === "saved") {
                result.hideButtonPanel = false;
                result.buttons = "submit,delete";
            }
        }

        return result;
    }

    handleError(errors, callback) {
        const clone = immutable.fromJS(this.state).toJS();
        if ((typeof (errors)).toLowerCase() === "string") clone.errors = [errors];
        else clone.errors = errors;
        this.scrollTop = true;
        this.setState(clone, function () {
            if (callback) callback();
        });
    }

    render() {
        let allowEdit = true;
        let vm = this.state;
        let alert = null;

        if (vm.timecard && vm.timecard.statusCode.toLowerCase() !== "saved") {
            allowEdit = false;
            alert = <Alert bsStyle="danger">Timecard for the weekend {moment(vm.timecard.weekEnding).format("MM/DD/YYYY")} has been {vm.timecard.statusCode} already!</Alert>;

        } else if(vm.errors.length > 0) {
            alert = <Alert bsStyle="danger"><ul>
                {
                    vm.errors.map(err => <li key={err}>{err}</li>)
                }
                </ul></Alert>;
        }

        return(
            <div className="ap-form-container">
                <div className="container ap-top-margined">
                    <div className="row">
                        <div className="col-md-4 col-md-offset-4 text-center">
                            <ControlLabel>This timecard is for the week-ending</ControlLabel>
                            <FormControl componentClass="select" value={`${this.state.selectedTimecardId}|${this.state.selectedWeekEnding}`}
                                onChange={(evt) => this.onSelectedTimecardIdChanged(evt.target.value)}>
                                {this.state.weekEndings.map(we => <option key={we.timecardId} value={`${we.timecardId}|${moment(we.weekEnding).format("MM/DD/YYYY")}`}>{moment(we.weekEnding).format("MM/DD/YYYY")}</option>)}
                            </FormControl>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                                {alert}
                        </div>              
                    </div>
                </div>
                <TCDurationForm timecardId={this.state.selectedTimecardId} onNewTimecardAdded={this.onNewTimecardAdded} allowEdit={allowEdit} ref="durationForm"
                        onLoadTimecardCompleted={this.onLoadTimecardCompleted} weekEnding={this.state.selectedWeekEnding} hideGrid={true}
                        clockeditTcRoute={this.props.clockeditTcRoute}/>
                <TCButtonPanel buttons={this.state.buttons}
                        hidden={this.state.hideButtonPanel}                
                        onSubmit={this.onSubmitTimecard}
                        onDelete={this.onDeleteTimecard}/>
            </div>
            );
    }
}
